import { useEffect, useRef } from 'react';

import { useStoreContext } from 'features/store';

import { useOrderContext } from 'state/order';
import { useServiceModeContext } from 'state/service-mode';

import { useCheckoutContext } from './use-checkout-context';
import { useCheckoutPriceOrder } from './use-checkout-price-order';

export const useCheckoutStoreChangeReprice = () => {
  const { storeChangeRepriceRequestId } = useOrderContext();
  const { serviceMode } = useServiceModeContext();
  const { store } = useStoreContext();
  const { serverOrder } = useCheckoutContext();
  const { priceCheckoutOrderForStoreChange } = useCheckoutPriceOrder();
  const lastHandledRequestIdRef = useRef(0);
  const selectedStoreNumber = store?.number ?? null;
  const serverOrderStoreNumber =
    serverOrder?.cart?.storeDetails?.storeNumber ??
    serverOrder?.cart?.storeId?.toString?.() ??
    null;

  useEffect(() => {
    if (
      !storeChangeRepriceRequestId ||
      lastHandledRequestIdRef.current >= storeChangeRepriceRequestId ||
      !serverOrder?.rbiOrderId ||
      !serviceMode ||
      !selectedStoreNumber ||
      !serverOrderStoreNumber
    ) {
      return;
    }

    if (selectedStoreNumber === serverOrderStoreNumber) {
      lastHandledRequestIdRef.current = storeChangeRepriceRequestId;
      return;
    }

    const didQueueReprice = priceCheckoutOrderForStoreChange(serviceMode);
    if (didQueueReprice) {
      lastHandledRequestIdRef.current = storeChangeRepriceRequestId;
    }
  }, [
    storeChangeRepriceRequestId,
    priceCheckoutOrderForStoreChange,
    serverOrder?.rbiOrderId,
    selectedStoreNumber,
    serviceMode,
    serverOrderStoreNumber,
  ]);
};
